const fromAnyToString = (any) => (any === null || any === undefined ? '' : String(any));

export default fromAnyToString;
